import { render, staticRenderFns } from "./OpenProduct.vue?vue&type=template&id=1b7e59dd&scoped=true&"
import script from "./OpenProduct.vue?vue&type=script&lang=js&"
export * from "./OpenProduct.vue?vue&type=script&lang=js&"
import style0 from "./OpenProduct.vue?vue&type=style&index=0&id=1b7e59dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e59dd",
  null
  
)

export default component.exports